import { createApi } from '@/api'
export default {
	getvoluntList: config => createApi( `/appointment/pageSearch`, 'post', config ),
	voluntDetail: config => createApi(`/appointment/get`, 'post', config),
	addvolunt: config => createApi(`/appointment/add`, 'post', config),
	deletevolunt: config => createApi(`/appointment/delete`, 'delete', config),
	updatevolunt: config => createApi(`/appointment/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/appointment/api/index.js